import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Default Buttons", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", { class: "d-flex gap-2 flex-wrap" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary fw-medium text-white py-2 px-4"
            }, " Primary "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary fw-medium text-white py-2 px-4"
            }, " Secondary "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success fw-medium text-white py-2 px-4"
            }, " Success "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger fw-medium text-white py-2 px-4"
            }, " Danger "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning fw-medium text-white py-2 px-4"
            }, " Warning "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info fw-medium text-white py-2 px-4"
            }, " Info "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light fw-medium text-white py-2 px-4"
            }, " Light "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-dark fw-medium text-white py-2 px-4"
            }, " Dark "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link fw-medium text-white py-2 px-4"
            }, " Link ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<button type=\"button\" class=\"btn btn-primary fw-medium text-white py-2 px-4\">Primary</button>\n<button type=\"button\" class=\"btn btn-secondary fw-medium text-white py-2 px-4\">Secondary</button>\n<button type=\"button\" class=\"btn btn-success fw-medium text-white py-2 px-4\">Success</button>\n<button type=\"button\" class=\"btn btn-danger fw-medium text-white py-2 px-4\">Danger</button>\n<button type=\"button\" class=\"btn btn-warning fw-medium text-white py-2 px-4\">Warning</button>\n<button type=\"button\" class=\"btn btn-info fw-medium text-white py-2 px-4\">Info</button>\n<button type=\"button\" class=\"btn btn-light fw-medium text-white py-2 px-4\">Light</button>\n<button type=\"button\" class=\"btn btn-dark fw-medium text-white py-2 px-4\">Dark</button>\n<button type=\"button\" class=\"btn btn-link fw-medium text-white py-2 px-4\">Link</button>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}